module.exports = __webpack_public_path__ + "img/눈.68e7ab85.png";